/**
 * Shared `sx` fragment that hides the MUI underline (the before/after/hover
 * pseudo-elements) on an InputBase. Used by BaseNumericField, BaseSelect and
 * BaseTextField so the underline-removal styling stays identical across the
 * form-field atoms.
 *
 * Both selectors are needed because the atoms land this `sx` on different
 * nodes: BaseTextField/BaseNumericField target a TextField, whose root is a
 * FormControl *containing* the InputBase (`& .`), while BaseSelect targets a
 * standard-variant Select, which *is* its own InputBase root (`&.`).
 */
export const hiddenUnderlineSx = {
  "&.MuiInputBase-root, & .MuiInputBase-root": {
    "&:after": { display: "none" },
    "&:before": { display: "none" },
    "&:hover:not(.Mui-disabled):before": { display: "none" }
  }
} as const;
